import { AntInput } from './styles'

export default AntInput
